import { render, staticRenderFns } from "./GenericDocumentCard.vue?vue&type=template&id=170aeae4"
import script from "./GenericDocumentCard.vue?vue&type=script&lang=js"
export * from "./GenericDocumentCard.vue?vue&type=script&lang=js"
import style0 from "./GenericDocumentCard.vue?vue&type=style&index=0&id=170aeae4&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('170aeae4')) {
      api.createRecord('170aeae4', component.options)
    } else {
      api.reload('170aeae4', component.options)
    }
    module.hot.accept("./GenericDocumentCard.vue?vue&type=template&id=170aeae4", function () {
      api.rerender('170aeae4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Card/GenericDocumentCard.vue"
export default component.exports